import { render } from "./AppointmentInfo.vue?vue&type=template&id=0972d08d&ts=true"
import script from "./AppointmentInfo.vue?vue&type=script&lang=ts"
export * from "./AppointmentInfo.vue?vue&type=script&lang=ts"

import "./AppointmentInfo.vue?vue&type=style&index=0&id=0972d08d&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__